module.exports = new __parcel__URL__("tabs_zh-tw.c0348324.webp").toString();